import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
} from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import {
  useCommonContent,
  useOneCmsLocalePartners,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import LoungeTermsContent from '@/components/common/LoungeTermsContent';
import {
  useLoungeAccessListMatchedWithLocaleProviders,
  useLoungeProviderId,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { useModal } from '@/context/modalContext';
import { splitAccessAndGuestPolicyHeader } from '@/helpers/utils';
import { getIsLoggedIn } from '@/selectors/authSelectors';
import { getLocaleData } from '@/selectors/localeSelectors';
import { useSelectedProductFromUserWallet } from '@/hooks/memberHooks';
import { CenturionProviders } from '@/constants';
import LoginCard from '../LoginCard';

const GuestPolicyModal = () => {
  const { loungeId, product } = useRouteParams();
  const providerId = useLoungeProviderId(loungeId);
  const { locale } = useSelector(getLocaleData);
  const userProduct = useSelectedProductFromUserWallet(product, locale);
  const { closeModal } = useModal();
  const {
    lounges: { agTab, guestModal },
    login: { label },
    footer: { additionalInfo },
  } = useCommonContent();
  const partners = useOneCmsLocalePartners();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const [, guestPolicyHeaderText] = splitAccessAndGuestPolicyHeader(agTab);
  const { guestPolicy } =
    useLoungeAccessListMatchedWithLocaleProviders(loungeId);
  const id = 'guest-policy';
  const isGuestBenefitEligible =
    userProduct?.guestBenefitEligible &&
    providerId === CenturionProviders.UnitedStates;

  return (
    <Modal
      id={id}
      onClose={(e) => closeModal(e, 'close guest policy')}
      innerContainerClassName="tw-modal-inner-container"
    >
      <ModalHeader
        id={`${id}-header`}
        closeButtonProps={{ reactlytics: { disable: true } }}
      >
        <h3>{guestPolicyHeaderText}</h3>
      </ModalHeader>
      <ModalBody id={`${id}-content`} className="tw-modal-body">
        <div>
          {!isLoggedIn && <LoginCard label={label} />}
          <h4 className="tw-heading-xs-bold">
            {isGuestBenefitEligible
              ? guestModal?.complimentaryAccessHeader
              : guestModal?.policyHeader}
          </h4>
          {isGuestBenefitEligible && isLoggedIn && (
            <div className="tw-pt-2">
              <Badge
                className="tw-body-xs-bold"
                status={
                  userProduct?.hasGuestBenefit ? 'success' : 'information'
                }
                size="large"
                type="text"
              >
                {userProduct?.hasGuestBenefit
                  ? guestModal?.benefitActiveLabel
                  : guestModal?.benefitInactiveLabel}
              </Badge>
            </div>
          )}
          <div className="tw-pt-2">
            {isGuestBenefitEligible
              ? userProduct?.hasGuestBenefit
                ? guestModal?.benefitActiveText
                : guestModal?.benefitInactiveText
              : guestPolicy}
          </div>
          <hr
            className="tw-my-6 tw-border-gray-300"
            aria-hidden="true"
            style={{ width: 'unset' }}
          />
          <h4 className="tw-heading-xs-bold tw-pb-2 tw-text-sm">
            {additionalInfo?.termsLabel}
          </h4>
          <LoungeTermsContent
            loungeId={loungeId}
            partners={partners}
            textCustomStyles="tw-text-gray-700"
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default GuestPolicyModal;
